import { IconContent } from '@icons';

export const clinicalFilled: IconContent = {
    md: '<path fill-rule="evenodd" d="M1.875 8.625c0 1.84.882 3.472 2.247 4.499l7.873 7.873 7.845-7.845A5.625 5.625 0 1 0 12 5.25 5.625 5.625 0 0 0 1.875 8.626ZM9.372 12.5l.79-2.636 1.354 5.26.948.062 1.482-3.704.814 1.018H18v-1h-2.76l-1.05-1.312-.854.126-1.232 3.08-1.42-5.519-.963-.019L8.628 11.5H6v1h3.372Z" />',
};
